export const mapStyle = [
  {
    "elementType": "geometry",
    "stylers": [
      {
        "visibility": "simplified",
      },
    ],
  },
  {
    "elementType": "geometry.fill",
    "stylers": [
      {
        "visibility": "on",
      },
    ],
  },
  {
    "elementType": "labels.text",
    "stylers": [
      {
        "visibility": "on",
      },
    ],
  },
  {
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "visibility": "on",
      },
    ],
  },
  {
    "elementType": "labels.text.stroke",
    "stylers": [
      {
        "visibility": "simplified",
      },
    ],
  },
  {
    "featureType": "administrative.country",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "visibility": "simplified",
      },
    ],
  },
  {
    "featureType": "administrative.land_parcel",
    "stylers": [
      {
        "visibility": "off",
      },
    ],
  },
  {
    "featureType": "administrative.neighborhood",
    "stylers": [
      {
        "visibility": "off",
      },
    ],
  },
  {
    "featureType": "landscape.man_made",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "color": "#b59e58",
      },
      {
        "saturation": -5,
      },
      {
        "lightness": 50,
      },
    ],
  },
  {
    "featureType": "landscape.natural",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "color": "#bed8b0",
      },
      {
        "saturation": -40,
      },
      {
        "lightness": 35,
      },
    ],
  },
  {
    "featureType": "landscape.natural.landcover",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "lightness": 100,
      },
    ],
  },
  {
    "featureType": "landscape.natural.terrain",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "lightness": 100,
      },
    ],
  },
  {
    "featureType": "poi",
    "stylers": [
      {
        "visibility": "off",
      },
    ],
  },
  {
    "featureType": "poi",
    "elementType": "labels.text",
    "stylers": [
      {
        "visibility": "off",
      },
    ],
  },
  {
    "featureType": "poi.attraction",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "lightness": 30,
      },
    ],
  },
  {
    "featureType": "poi.attraction",
    "elementType": "labels.icon",
    "stylers": [
      {
        "visibility": "off",
      },
    ],
  },
  {
    "featureType": "poi.business",
    "stylers": [
      {
        "visibility": "off",
      },
    ],
  },
  {
    "featureType": "poi.business",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "color": "#d8dbc9",
      },
    ],
  },
  {
    "featureType": "poi.business",
    "elementType": "labels.icon",
    "stylers": [
      {
        "visibility": "off",
      },
    ],
  },
  {
    "featureType": "poi.government",
    "elementType": "labels.icon",
    "stylers": [
      {
        "visibility": "off",
      },
    ],
  },
  {
    "featureType": "poi.medical",
    "elementType": "labels.icon",
    "stylers": [
      {
        "visibility": "off",
      },
    ],
  },
  {
    "featureType": "poi.park",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "color": "#ccdbc7",
      },
      {
        "lightness": 55,
      },
    ],
  },
  {
    "featureType": "poi.park",
    "elementType": "labels.text",
    "stylers": [
      {
        "visibility": "off",
      },
    ],
  },
  {
    "featureType": "poi.place_of_worship",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "color": "#ccdbc7",
      },
    ],
  },
  {
    "featureType": "poi.school",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "color": "#ccdbc7",
      },
    ],
  },
  {
    "featureType": "poi.sports_complex",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "visibility": "on",
      },
    ],
  },
  {
    "featureType": "road",
    "elementType": "labels",
    "stylers": [
      {
        "visibility": "off",
      },
    ],
  },
  {
    "featureType": "road.arterial",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "color": "#acb09c",
      },
      {
        "weight": 0.5,
      },
    ],
  },
  {
    "featureType": "road.highway",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "color": "#acb09c",
      },
      {
        "weight": 1.5,
      },
    ],
  },
  {
    "featureType": "road.highway.controlled_access",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "color": "#acb09c",
      },
    ],
  },
  {
    "featureType": "road.local",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "color": "#acb09c",
      },
      {
        "weight": 0.5,
      },
    ],
  },
  {
    "featureType": "transit.line",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "color": "#acb09c",
      },
    ],
  },
  {
    "featureType": "transit.station",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "color": "#acb09c",
      },
    ],
  },
  {
    "featureType": "transit.station.airport",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "color": "#acb09c",
      },
      {
        "lightness": 75,
      },
    ],
  },
  {
    "featureType": "transit.station.bus",
    "elementType": "labels.icon",
    "stylers": [
      {
        "visibility": "off",
      },
    ],
  },
  {
    "featureType": "transit.station.rail",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "color": "#acb09c",
      },
    ],
  },
  {
    "featureType": "water",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "color": "#ccfdff",
      },
      {
        "saturation": -60,
      },
    ],
  },
  {
    "featureType": "water",
    "elementType": "labels.text",
    "stylers": [
      {
        "visibility": "off",
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./scripts/vue/constants.js